// src/config/config.js

// Configuración para sistema multitenant Horeb
const config = {
  // API URL - Detectar automáticamente según el entorno
  API_URL: (() => {
    // Si estamos en desarrollo
    if (process.env.NODE_ENV === 'development') {
      // Si hay una variable de entorno específica, usarla
      if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
      }
      
      // Para el portal admin en desarrollo
      if (window.location.hostname === 'localhost' && window.location.port === '3000') {
        return 'http://localhost:3001/api'; // Puerto del admin-api
      }
      
      // Para pruebas locales de Balcones
      return 'http://localhost:3002/api'; // Puerto del backend de Balcones
    }
    
    // Producción - detectar automáticamente según el dominio
    const hostname = window.location.hostname;
    
    if (hostname.includes('admin.horebapps.com')) {
      // 🔧 CORRECCIÓN: Portal administrativo central con puerto 3001
      return 'https://admin.horebapps.com/api';
    } else if (hostname.includes('balcones.horebapps.com')) {
      // Conjunto Balcones en Hostinger
      return 'https://balcones.horebapps.com/api';
    } else if (hostname.includes('app.balconesdeljardin.com')) {
      // Sistema actual de Balcones en DonWeb
      return 'https://app.balconesdeljardin.com:8443/api';
    } else {
      // Fallback para otros conjuntos
      return `https://${hostname}/api`;
    }
  })(),

  // Configuración de ReCAPTCHA
  RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LfH8g8qAAAAAKxSLNBE0pJ7wKhFZGEH3PN8iPNY',

  // Configuración de timeouts y reintentos
  TIMEOUT: {
    DEFAULT: 30000, // 30 segundos
    UPLOAD: 60000,  // 60 segundos para uploads
    DOWNLOAD: 120000 // 2 minutos para descargas
  },

  // Configuración de paginación
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 20,
    PAGE_SIZE_OPTIONS: [10, 20, 50, 100]
  },

  // Configuración de archivos
  FILE_UPLOAD: {
    MAX_SIZE: 10 * 1024 * 1024, // 10MB
    ALLOWED_TYPES: {
      IMAGES: ['jpg', 'jpeg', 'png', 'gif', 'webp'],
      DOCUMENTS: ['pdf', 'doc', 'docx', 'xls', 'xlsx'],
      COMPRESSED: ['zip', 'rar', '7z']
    }
  },

  // Configuración de fecha y hora
  DATE_FORMAT: {
    DISPLAY: 'DD/MM/YYYY',
    DISPLAY_WITH_TIME: 'DD/MM/YYYY HH:mm',
    API: 'YYYY-MM-DD'
  },

  // Configuración de notificaciones
  NOTIFICATION: {
    DURATION: 4.5,
    PLACEMENT: 'topRight'
  },

  // Configuración específica del entorno
  ENVIRONMENT: process.env.NODE_ENV || 'development',
  
  // Debug mode
  DEBUG: process.env.NODE_ENV === 'development',

  // Configuración de intervalos de actualización (en milisegundos)
  REFRESH_INTERVALS: {
    DASHBOARD: 30000, // 30 segundos
    NOTIFICATIONS: 60000, // 1 minuto
    SYSTEM_STATUS: 120000 // 2 minutos
  }
};

// Validaciones de configuración
if (config.DEBUG) {
  console.log('🔧 Configuración cargada:', {
    API_URL: config.API_URL,
    ENVIRONMENT: config.ENVIRONMENT,
    HOSTNAME: window.location.hostname,
    PORT: window.location.port
  });
}

// Verificar que la API_URL sea válida
if (!config.API_URL || config.API_URL === 'undefined') {
  console.error('❌ ERROR: API_URL no está configurada correctamente');
  console.log('Variables de entorno disponibles:', process.env);
}

export default config;